import React from 'react';
import { Box, Divider, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 'auto', pt: 3 }}>
      <Divider sx={{ mb: 3 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: 1,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          © {currentYear} R2B Platform. All rights reserved.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Link component={RouterLink} to="/privacy-policy" underline="hover" variant="body2" color="primary">
            Privacy Policy
          </Link>
          <Link component={RouterLink} to="/terms-of-service" underline="hover" variant="body2" color="primary">
            Terms of Service
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
